import { useSelector } from "react-redux";
import ProductTile from "./ProductTile";
import OriginalProductTile from "../../../ProductTile";
import { getCategoryTreatments } from "../../../../../state/modules/category";
import { getViewportCategory } from "../../../../../state/modules/layout/selectors";
import { LARGE_VIEWPORT } from "../../../../../state/modules/layout/constants";

const ProductTileContainer = props => {
  const treatments = useSelector(getCategoryTreatments);
  const viewportCategory = useSelector(getViewportCategory);

  if (treatments || viewportCategory !== LARGE_VIEWPORT) {
    return <OriginalProductTile {...props} />;
  }

  return <ProductTile {...props} />;
};

export default ProductTileContainer;
